export default (state, action) => {
  return Object.assign({}, state, {
    page_data: action.pageData,
    pageLoading: false,
  });
};
